module.exports = __webpack_public_path__ + "static/media/Profile 2.642cfdb4.svg";